import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { ForeignTravelModel } from './types';
import { foreignTravelItemValidator } from './validators/item';

const foreignTravelValidator: ValidateJSModel<ForeignTravelModel> = {
  HasForeignTravelOutside: { presence: true, hasValue: { validator: hasYesOrNo } },

  HasForeignTravelOfficial: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    if (attributes?.HasForeignTravelOutside && attributes?.HasForeignTravelOutside.value === 'Yes') {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  List: (value, attributes, attributeName, options) => {
    const { HasForeignTravelOutside, HasForeignTravelOfficial } = attributes;

    if (isPVQForm(options?.formType)
      && HasForeignTravelOutside
      && HasForeignTravelOutside.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignTravelItemValidator }
      };
    }

    if (HasForeignTravelOutside
      && HasForeignTravelOutside.value === 'Yes'
      && HasForeignTravelOfficial
      && HasForeignTravelOfficial.value === 'No') {
      return {
        presence: true,
        accordion: { validator: foreignTravelItemValidator },
      };
    }

    return {};
  },
};

export default foreignTravelValidator;
